<div
  class="c-wizard-modal"
  [class.c-wizard-modal--fullScreen]="wizardModalData.fullScreen">
  @if (wizardModalData.steps[tab].closeable) {
    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>
  }

  <div class="c-wizard-modal__body">
    <div
      class="c-wizard-modal__background"
      [ngStyle]="{
        'background-image': 'url(' + wizardModalData.steps[tab].imageUrl + ')'
      }">
      @if (showArrows) {
        <div class="c-wizard-modal__arrows">
          <slotcom-navigation-button
            type="arrow-left"
            leftPosition="7"
            (click)="tab !== 0 ? changeTab(tab - 1) : changeTab(wizardModalData.steps.length - 1)">
          </slotcom-navigation-button>

          <slotcom-navigation-button
            type="arrow-right"
            rightPosition="7"
            (click)="tab !== wizardModalData.steps.length - 1 ? changeTab(tab + 1) : changeTab(0)">
          </slotcom-navigation-button>
        </div>
      }

      <ng-content></ng-content>
    </div>
  </div>

  <div class="c-wizard-modal__footer">
    @if (!showArrows) {
      <div class="c-wizard-modal__footerBack">
        <slotcom-button
          class="c-button--purple"
          [ngStyle]="{ visibility: tab !== 0 ? 'visible' : 'hidden' }"
          (click)="changeTab(tab - 1)"
          audioType="functionality">
          {{ 'home.buttons.go-back' | translate | uppercase }}
        </slotcom-button>
      </div>
    }

    @if (!showDots) {
      <div class="c-wizard-modal__footerCountBox">
        <span class="text">{{ tab + 1 }}/{{ wizardModalData.steps.length }}</span>
      </div>
    } @else {
      <div
        [ngClass]="{ 'c-wizard-modal__footerDots--withArrows': showArrows }"
        class="c-wizard-modal__footerDots">
        @for (item of wizardModalData.steps; track item; let i = $index) {
          <div
            [class]="'dot dot-number-' + i"
            [ngClass]="{ 'dot-active': tab === i }"></div>
        }
      </div>
    }

    @if (!showArrows) {
      <div class="c-wizard-modal__footerNext">
        <slotcom-button
          id="modal-wizard-next-btn"
          class="c-button--pink"
          (click)="
            tab !== wizardModalData.steps.length - 1 ? changeTab(tab + 1) : closeByAction(wizardModalData.actionUrl)
          "
          audioType="functionality">
          {{
            wizardModalData.steps[tab].buttonText
              ? (wizardModalData.steps[tab].buttonText | uppercase)
              : ('home.buttons.forward' | translate | uppercase)
          }}
        </slotcom-button>
      </div>
    }
  </div>
</div>
